"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = require("styled-components");
const oxygen_constants_1 = require("@8x8/oxygen-constants");
const getColors = ({ theme, type }) => {
    switch (type) {
        // @deprecated
        case oxygen_constants_1.badgeType.secondary:
            return (0, styled_components_1.css) `
        color: ${theme.fontColorSecondary};
        background-color: ${theme.backgroundColorSecondary};
      `;
        case oxygen_constants_1.badgeType.primary:
        default:
            return (0, styled_components_1.css) `
        color: ${theme.fontColorPrimary};
        background-color: ${theme.backgroundColorPrimary};
      `;
    }
};
exports.default = getColors;
